PT.Utils.Clipboard = class CopyClipboard
  constructor: ->
    @el = new Clipboard('[data-clipboard-target]')
    @preCopyText = 'Copy to clipboard'
    @postCopyText = 'Copied!'

    @bindEvents()

  bindEvents: ->
    @el.on 'success', @onClipboardSuccess
    @el.on 'error', @onClipboardError
    $(document).on 'mouseleave', '[data-clipboard-target]', @onClipboardMouseleave

  ## Methods

  hasTooltip: (el) ->
    el.hasAttribute 'data-pt-tooltip'

  showTooltip: (el) ->
    el.classList.add 'tooltip-on'

  setTooltipText: (el, text) ->
    el.setAttribute 'data-pt-tooltip', text

  resetTooltipText: (el) ->
    @setTooltipText el, @preCopyText

  ## Event Handlers

  onClipboardMouseleave: (e) =>
    return unless @hasTooltip(e.currentTarget)

    @resetTooltipText e.currentTarget

  onClipboardSuccess: (e) =>
    return unless @hasTooltip(e.trigger)

    @showTooltip e.trigger
    @setTooltipText e.trigger, @postCopyText

  onClipboardError: (e) =>
    return unless @hasTooltip(e.trigger)

    key = if e.action == 'cut' then 'X' else 'C'

    if /iPhone|iPad/i.test(navigator.userAgent)
      text = 'No support :('
    else if /Mac/i.test(navigator.userAgent)
      text = 'Press ⌘-' + key + ' to ' + e.action
    else
      text = 'Press Ctrl-' + key + ' to ' + e.action

    @showTooltip e.trigger
    @setTooltipText e.trigger, text
